import * as R from "ramda";
import { HEADER } from "@/actions/constants";

const initialState = {
  userMenuCollapsed: false,
  commonMenuCollapsed: false,
};

export function header(state = initialState, action = {}) {
  switch (action.type) {
    case HEADER.TOGGLE_USER_MENU:
      return R.assoc("userMenuCollapsed", R.not(state.userMenuCollapsed), state);
    case HEADER.TOGGLE_COMMON_MENU:
      return R.assoc("commonMenuCollapsed", R.not(state.commonMenuCollapsed), state);
    case HEADER.CLOSE_MENUS:
      return R.mergeLeft(
        { userMenuCollapsed: false, commonMenuCollapsed: false },
        state
      );
    default:
      return state;
  }
}
